"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgClipboardReplaceOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.clipboard-replace_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "clipboard-replace_outline_svg__transparent_box" },
            React.createElement("path", { className: "clipboard-replace_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "clipboard-replace_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "clipboard-replace_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M18 10V8h3v3h2V6h-5v.18a4 4 0 00-.75-2.71A4.5 4.5 0 0013.5 2a4.51 4.51 0 00-3.76 1.47A3.85 3.85 0 009 6H4v24h5v-2H6V8h3v2zm-7-3.82c0-1 .13-1.23.33-1.5A2.79 2.79 0 0113.5 4a2.72 2.72 0 012.16.68c.2.28.34.53.34 1.5V8h-5z" }),
            React.createElement("path", { d: "M20.51 28a5.51 5.51 0 01-4.23-2H19v-2h-6v6h2v-2.43a7.48 7.48 0 0012.8-3.34l-1.95-.46A5.46 5.46 0 0120.51 28zM26 15v2.42a7.48 7.48 0 00-12.79 3.35l1.95.46A5.49 5.49 0 0124.74 19H22v2h6v-6z" }))));
}
exports.default = SvgClipboardReplaceOutline;
//# sourceMappingURL=ClipboardReplaceOutline.js.map